module.exports = __webpack_public_path__ + "assets/img/9490-gb-wls.svg";